import Vue from "vue";

const componentsSources = require.context(
  "@/components",
  true,
  /^(?!.*(?:doc.vue$)).*\.vue$/
);

componentsSources.keys().forEach(path => {
  const componentOptions = componentsSources(path).default;
  Vue.component(componentOptions.name, componentOptions);
});
